import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'mobx-react';
import { when } from 'mobx';

import './services/NetworkingClient';

import '@patternfly/react-core/dist/styles/base.css';

import Layout from 'components/Layout';
import rootStore from './stores';
import configureI18n from './config/i18n';
import configureSentry from './config/sentry';
import configureRouter from './config/router5';

import '@ole-ui/ole-ui-components/dist/styles/index.css';
import './styles/base.scss';

when(
  () =>
    rootStore.configStore.didFetchConfig === true &&
    rootStore.configStore.rezodePlatform,
  () => {
    configureSentry(rootStore.configStore.shouldSkipSentry);
  },
);

const isDevelopmentEnv = process.env.NODE_ENV === 'development';
const isAccessibilityCheckEnabled = false; // turning this on will cause some renders to be significantly slower

configureI18n(rootStore.uiStore);

const router = configureRouter(isDevelopmentEnv, rootStore);

const app = document.getElementById('app');
const root = createRoot(app);

function renderReactDOM() {
  root.render(
    <Provider {...rootStore}>
      <Suspense fallback="">
        <Layout />
      </Suspense>
    </Provider>,
  );
}

router.start(() => {
  if (isDevelopmentEnv && isAccessibilityCheckEnabled) {
    import('react-axe').then((axe) => {
      axe.default(React, root, 1000);
      renderReactDOM();
    });
  } else {
    renderReactDOM();
  }
});
